import { useRef, useState } from "react";
import { Box, Popover, TextField } from "@mui/material";
import { ColorSwatch } from "../style";

/**
 * Minimal color picker: swatch opens a popover with native color input + hex text field.
 * Uses MUI Popover so it auto-flips inside the viewport — never gets clipped by
 * containing panels.
 */
export default function ColorPicker({ value, onChange, label }) {
  const swatchRef = useRef(null);
  const [open, setOpen] = useState(false);

  // strip alpha for native input (it only handles #rrggbb)
  const hexColor = value ? value.slice(0, 7) : "#000000";

  return (
    <>
      {label && <Box component="span" sx={{ fontSize: 12, color: "text.secondary", mr: 1 }}>{label}</Box>}
      <ColorSwatch
        ref={swatchRef}
        color={hexColor}
        onClick={() => setOpen((v) => !v)}
        title={value}
      />
      <Popover
        open={open}
        anchorEl={swatchRef.current}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        marginThreshold={12}
        slotProps={{
          paper: {
            sx: {
              p: 1,
              mt: 0.5,
              display: "flex",
              flexDirection: "column",
              gap: 1,
              minWidth: 160,
            },
          },
        }}
      >
        <input
          type="color"
          value={hexColor}
          onChange={(e) => {
            const alpha = value && value.length === 9 ? value.slice(7) : "";
            onChange(e.target.value + alpha);
          }}
          style={{ width: "100%", height: 36, border: "none", padding: 0, cursor: "pointer" }}
        />
        <TextField
          size="small"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#rrggbb"
          inputProps={{ style: { fontSize: 12 }, maxLength: 9 }}
        />
      </Popover>
    </>
  );
}
